import { useState, useEffect } from 'react';
import { BottomSheet } from 'react-spring-bottom-sheet';
import NoOutletImg from '../../../common/images/revamp/images/no-outlet.png';
import Delivery from '../../Delivery';

const NoOutlet = (props) => {
	const { isOpen, onClose, sameLocation } = props;
	const [isOpenBottomSheet, setIsOpenBottomSheet] = useState(false);
	const [isOpenDelivery, setIsOpenDelivery] = useState(false);

	const handleClick = () => {
		setIsOpenDelivery(true);
	};

	const handleClose = () => {
		setIsOpenDelivery(false);
		setIsOpenDelivery(false);
		onClose?.();
	};

	useEffect(() => {
		setIsOpenBottomSheet(isOpen);
	}, [isOpen]);

	const deliveryProps = {
		isOpenDelivery,
		onClose: handleClose,
	};

	return (
		<>
			<BottomSheet open={isOpenBottomSheet} onDismiss={handleClose}>
				<div className='px-4 pb-4'>
					<img src={NoOutletImg} alt='no-outlet' className='h-[182px] mx-auto mb-4' />
					<p className='text-[var(--dark-gray)] font-semibold text-sm px-6 mb-1.5 text-center'>
						{sameLocation ? `Oops! Alamat penjemputan dan tujuan terlalu dekat. Coba pilih alamat lain!` : `Maaf, tidak ada restoran yang tersedia di sekitar lokasi Anda`}
					</p>
					<p className='text-[var(--dark-gray)] text-xxs px-1 mb-8 text-center'>Silakan ubah lokasi Anda untuk menemukan promo menarik dari restoran.</p>
					<button
						className='border border-solid border-[var(--rose-violet)] text-[var(--rose-violet)] w-full py-2.5 text-center text-xs font-semibold rounded hover:bg-[var(--rose-violet)] hover:text-white transition-all'
						onClick={handleClick}>
						Ubah Lokasi
					</button>
				</div>
			</BottomSheet>
			<BottomSheet
				key={'delivery-location'}
				open={isOpenDelivery}
				onDismiss={handleClose}
				snapPoints={({ minHeight, maxHeight }) => {
					return [minHeight, maxHeight * 0.75];
				}}>
				<Delivery {...deliveryProps} />
			</BottomSheet>
		</>
	);
};

export default NoOutlet;
